import api from "./api";

export const requestDataMap = (item) => ({
  requestId: item?._id ?? null,

  pocId: item?.transaction?.poc?._id ?? null,
  pocName: item?.transaction?.poc?.name ?? null,
  material: item?.transaction?.material.category ?? null,
  materialId: item?.transaction?.material._id ?? null,
  quantity: item?.transaction?.quantity,
  unit: item?.transaction?.material?.unit,
  materialPoint: item?.transaction?.material?.point,

  transactionPoints: item?.transaction?.transaction_point ?? null,

  // requestedId: item?.request_profile?._id, // Deprecated
  requestProfileId: item?.request_profile?._id,
  profileName: item?.request_profile?.name,
  requestProfileCreateDate: item?.request_profile?.create_date ?? null,

  profileEmail: item?.request_entity?.authentication_string, // To deprecate this...
  requestEntityId: item?.request_entity?._id,
  requestEntityName: item?.request_entity?.name ?? null,
  requestEmail: item?.request_entity?.authentication_string ?? null,

  targetEmail: item?.target_entity?.authentication_string,
  targetEntityName: item?.target_entity?.name ?? null,

  targetProfile: item?.target_profile?.name,
  targetProfileId: item?.target_profile?._id ?? null,

  email: item?.email ?? null,
  reason: item?.reason ?? null,

  communityId: item?.community?._id ?? null,
  communityName: item?.community?.name ?? null,

  groupID: item?.group?._id ?? null,
  groupName: item?.group?.name ?? null,
  groupLeader:
    item?.group?.leaders?.length > 0 ? item.group.leaders.join(", ") : null,

  type:
    item?.type === "I"
      ? "Invitation"
      : item?.type === "A"
      ? "Activation"
      : item?.type === "S"
      ? "Suspension"
      : item?.type === "R"
      ? "Removal"
      : item?.type === "T"
      ? "Transaction Review"
      : item?.type === "RA"
      ? "Reassignment"
      : "Unknown",
  status:
    item?.status === "A"
      ? "Approved"
      : item?.status === "P"
      ? "Pending"
      : item?.status === "R"
      ? "Rejected"
      : "Unknown",

  description: item?.description ?? null,

  dateCreated: item?.create_date
    ? new Date(item.create_date).toLocaleString()
    : null,
  dateUpdated: item?.last_update
    ? new Date(item.last_update).toLocaleString()
    : null,
});

export const requestService = {
  addRequest: async (requestData) => {
    try {
      console.log("Adding new Requests:", requestData);
      const response = await api.post(`/mapi/request/addRequest`, requestData);
      return response.data;
    } catch (error) {
      console.error(
        "Error adding new Requests:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getRequests: async (
    EntityId,
    ProfileId,
    RequestId,
    CommunityId,
    GroupId,
    Type
  ) => {
    try {
      // console.log("Calling get requests API:", {
      //   EntityId,
      //   ProfileId,
      //   RequestId,
      //   CommunityId,
      //   GroupId,
      //   Type,
      // });

      // Build query parameters dynamically
      const params = new URLSearchParams();
      if (EntityId) params.append("EntityId", EntityId);
      if (ProfileId) params.append("ProfileId", ProfileId);
      if (RequestId) params.append("RequestId", RequestId);
      if (CommunityId) params.append("CommunityId", CommunityId);
      if (GroupId) params.append("GroupId", GroupId);
      if (Type) params.append("Type", Type); // <-- Added Type param here

      const url = `/mapi/request/getRequest${
        params.toString() ? "?" + params.toString() : ""
      }`;

      const response = await api.get(url);
      // console.log("Get requests response:", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching request list data:",
        error.response?.data || error.message
      );
      return [];
      // throw error;
      // Don't throw and crash the app
    }
  },

  acceptRequest: async (requestPayload) => {
    try {
      console.log("Accepting request:", requestPayload);
      const response = await api.post(
        `/mapi/request/acceptRequest`,
        requestPayload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error accepting request:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  rejectRequest: async ({ RequestId, Comment }) => {
    try {
      console.log("Rejecting request:", { RequestId, Comment });
      const response = await api.post(`/mapi/request/rejectRequest`, {
        RequestId,
        Comment,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error rejecting request:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  removeRequest: async ({ OperatorId, RequestId }) => {
    try {
      console.log("Removing request:", { OperatorId, RequestId });
      const response = await api.post(`/mapi/request/removeRequest`, {
        OperatorId,
        RequestId,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error removing request:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default requestService;
